export default __webpack_public_path__ + "static/media/level 1.05c8bd28.svg";